/**
 * Anonymous public data embedded by scripts/prerender.mjs.
 * Only present on public prerendered HTML; SPA fallback routes simply return null.
 */
let cachedSnapshot;

function normalizedPath(path) {
  return String(path || '/').toLowerCase().replace(/\/+$/, '') || '/';
}

export function getPrerenderData() {
  if (cachedSnapshot !== undefined) return cachedSnapshot;
  cachedSnapshot = null;
  if (typeof document === 'undefined') return null;

  const element = document.getElementById('pa-prerender-data');
  if (!element?.textContent) return null;

  try {
    const value = JSON.parse(element.textContent);
    if (value?.version === 1 && typeof value.path === 'string') {
      cachedSnapshot = value;
    }
  } catch {
    // Invalid or absent build snapshot: use the ordinary API loading path.
  }
  return cachedSnapshot;
}

export function getInitialPromotions() {
  const state = getPrerenderData();
  if (!state || !Array.isArray(state.promotions)) return null;
  return state.promotions;
}

export function getInitialProductData(productURI) {
  if (typeof window === 'undefined') return null;
  const state = getPrerenderData();
  const slug = String(productURI || '').toLowerCase();
  if (!state || normalizedPath(state.path) !== normalizedPath(window.location.pathname) ||
      normalizedPath(state.path) !== `/products/${slug}` ||
      String(state.product?.productURI || '').toLowerCase() !== slug ||
      !Array.isArray(state.allProducts)) return null;

  return { product: state.product, allProducts: state.allProducts };
}
